export default __webpack_public_path__ + "static/icon-sm-02e0fdf9ddd51d35c73c212ad87524e2.png";